import { OrganizationIntegrationsSettings } from '#/models/organization/OrganizationIntegrationsSettings';
import { FiskalyIntegrationFormData } from '#/pages/organizationSettings/integrations/components/otherIntegrations/modals/fiskalyIntegrationModal/FiskalyIntegration.schema';
import { OnlygalIntegrationFormData } from '#/pages/organizationSettings/integrations/components/otherIntegrations/modals/onlygalIntegrationModal/OnlygalIntegration.schema';
import { RespondioIntegrationFormData } from '#/pages/organizationSettings/integrations/components/otherIntegrations/modals/respondioIntegrationModal/RespondioIntegration.schema';
import { SlackIntegrationFormData } from '#/pages/organizationSettings/integrations/components/otherIntegrations/modals/slackIntegrationModal/SlackIntegration.schema';
import { ZendeskIntegrationFormData } from '#/pages/organizationSettings/integrations/components/otherIntegrations/modals/zendeskIntegrationModal/ZendeskIntegration.schema';
import { DateVO } from '@zazume/zzm-utils';
import { doGet, doPut } from '../../helpers';

const parse = (raw: any): OrganizationIntegrationsSettings =>
  new OrganizationIntegrationsSettings({
    _id: raw._id,
    organizationId: raw._id,
    respondio: raw.respondio,
    zendesk: raw.zendesk,
    onlygal: raw.onlygal,
    slack: raw.slack,
    createdAt: DateVO.fromPrimitive(raw),
    fiskaly: raw.fiskaly
  });

export const organizationIntegrationsSettings = {
  findIntegrationsSettings: () =>
    doGet<OrganizationIntegrationsSettings>('/dashboard/organization-integrations-settings', parse, undefined, { expectNotFound: true }),
  updateRespondioSettings: (body: RespondioIntegrationFormData) =>
    doPut<void>('/dashboard/organization-integrations-settings/respondio', body),
  updateZendeskSettings: (body: ZendeskIntegrationFormData) =>
    doPut<void>('/dashboard/organization-integrations-settings/zendesk', body),
  updateOnlygalSettings: (body: OnlygalIntegrationFormData) =>
    doPut<void>('/dashboard/organization-integrations-settings/onlygal', body),
  updateSlackSettings: (body: SlackIntegrationFormData) =>
    doPut<void>('/dashboard/organization-integrations-settings/slack', body),
  updateFiskalySettings: (body: FiskalyIntegrationFormData) =>
    doPut<void>('/dashboard/organization-integrations-settings/fiskaly', body)
};
